<template>
<div class="card-container">
  <a-tabs v-model="activeKey" @change="changeTab" class="new-tabs">
    <a-tab-pane :key="1" :tab="$t('命令详情列表')">
      <a-row :gutter="10" class="new-row">
        <a-col :md="collapsed?0: 5" :sm="24" class="new-col">
          <a-row :gutter="10" class="new-row">
            <a-card :bordered="false" class="new-tree-card">
              <!-- 按钮操作区域 -->
              <div style="background: #fff;padding-left:16px;height: 100%; margin-top: 5px">
                <a-alert type="info" :showIcon="true">
                  <div slot="message">
                    {{ $t('当前选择：') }}<span v-if="this.currSelected.title">{{ getCurrSelectedTitle() }}</span>
                    <a v-if="this.currSelected.title" style="margin-left: 10px" @click="unselect">{{ $t('取消选择') }}</a>
                  </div>
                </a-alert>
                <div style="display: flex;margin-top: 10px;">
                  <a-input-search v-model="searchAreaValue" style="width:100%;margin-right: 5px;" allowClear  :placeholder="$t('请输入区域名称')"/>
                  <a-button type="default" @click="collapseAll">{{ $t('折叠') }}</a-button>
                </div>
                <!-- 树-->
                <a-col :md="24" :sm="24" class="new-tree-col">
                  <template>
                    <a-spin tip="Loading..." :spinning="areaLoading">
                      <!--
                      <span style="user-select: none">
                        <a-tree
                          class="my-area-select-tree"
                          @select="onSelect"     
                          :selectedKeys="selectedKeys"
                          :treeData="areaTree"
                          :checkStrictly="checkStrictly"
                          :expandedKeys="iExpandedKeys"
                          :autoExpandParent="autoExpandParent"
                          defaultExpandParent
                          @expand="onExpand">
                          <template slot="title" slot-scope="{title}">
                            <span v-if="title.indexOf(searchAreaValue) > -1">
                              {{title.substr(0, title.indexOf(searchAreaValue))}}
                            <span style="color: #32CD32">{{searchAreaValue}}</span>
                              {{title.substr(title.indexOf(searchAreaValue) + searchAreaValue.length)}}
                            </span>
                            <span v-else>{{title}}</span>
                          </template>
                        </a-tree>
                      </span>
                      -->
                      <el-tree
                        class="filter-tree"
                        :data="areaTree"
                        :props="defaultProps"
                        :expand-on-click-node="false"
                        :filter-node-method="filterNode"
                        :check-on-click-node="true"
                        :check-strictly="checkStrictly"
                        :highlight-current="true"
                        node-key="id"
                        :current-node-key="currentNodeKey"
                        :default-expanded-keys="iExpandedKeys"
                        @node-click="nodeClick"
                        ref="areaTree">
                      </el-tree>
                    </a-spin>
                  </template>
                </a-col>
              </div>
            </a-card>
          </a-row>
        </a-col>
        <a-col :md="collapsed? 24: 19" :sm="24" style="position: relative;padding-left: 30px" class="new-col">
          <a-icon :type="collapsed ? 'caret-right':'caret-left'" 
            @click="collapsed = !collapsed"
            class="area-collapsed"></a-icon>
          <a-card :bordered="false" class="new-table-card">
            <!-- 查询区域 -->
            <div class="table-page-search-wrapper">
              <a-form layout="inline" @keyup.enter.native="searchQuery">
                <a-row :gutter="24">
                  <a-col :xl="6" :lg="7" :md="8" :sm="24">
                    <a-form-item :label="$t('表编号')">
                      <a-input  :placeholder="$t('请输入表编号')" v-model="queryParam.meterId"></a-input>
                    </a-form-item>
                  </a-col>
                  <a-col :xl="6" :lg="7" :md="8" :sm="24">
                    <a-form-item :label="$t('用户编号')">
                      <a-input  :placeholder="$t('请输入用户编号')" v-model="queryParam.userId"></a-input>
                    </a-form-item>
                  </a-col>
                  <a-col :xl="6" :lg="7" :md="8" :sm="24">
                    <a-form-item :label="$t('用户姓名')">
                      <a-input  :placeholder="$t('请输入用户姓名')" v-model="queryParam.userName"></a-input>
                    </a-form-item>
                  </a-col>
                  <template v-if="toggleSearchStatus">
                    <a-col :xl="6" :lg="7" :md="8" :sm="24">
                      <a-form-item :label="$t('运营商')">
                        <j-dict-select-tag v-model="queryParam.meterIotType"  :placeholder="$t('请选择运营商')" dictCode="mtIotType" />
                      </a-form-item>
                    </a-col>
                    <a-col :xl="6" :lg="7" :md="8" :sm="24">
                      <a-form-item :label="$t('表类型')">
                        
                        <a-select v-model="queryParam.meterType" :placeholder="$t('请输入表类型')" @change="changeMeterType">
                          <a-select-option v-for="data in userTypeList" :key="data.id" :value="data.mtCode">
                            {{data.mtName}}
                          </a-select-option>
                        </a-select>
                       
                        <!-- <j-dict-select-tag v-model="queryParam.meterType" placeholder="请表类型" :triggerChange="true" dictCode="meter_type" @change="changeMeterType" /> -->
                      </a-form-item>
                    </a-col>
                    
                    <a-col :xl="9" :lg="10" :md="11" :sm="24">
                      <a-form-item :label="$t('命令标识')" >
                        <a-select v-model="queryParam.cmd"  :placeholder="$t('请选择命令标识')">
                          <a-select-option v-for="(item,value) in cmdList"  :value="value" :key="value" :label="item" :title="item">
                            {{item}}
                          </a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                    <a-col :xl="6" :lg="7" :md="8" :sm="24">
                      <a-form-item :label="$t('通讯状态')">
                        <a-select  v-model="queryParam.status"  :placeholder="$t('请选择通讯状态')">
                          <a-select-option :value="value" :key="value" v-for="(item,value) in reportStatusObj">
                            {{item}}
                          </a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                    <a-col :xl="12" :lg="7" :md="8" :sm="24">
                      <a-form-item :label="$t('查询起止时间')">
                        <a-range-picker
                          v-model="date"
                          format="YYYY-MM-DD"
                          :placeholder="[$t('查询起始时间'), $t('查询结束时间')]"
                          @change="onDateRangeChange"
                          @ok="onOk"
                        />
                      </a-form-item>
                    </a-col>
                    <!-- <a-col :xl="10" :lg="7" :md="8" :sm="24">
                      <a-form-item label="iot平台创建的命令唯一标识 ">
                        <a-input placeholder="iot平台创建的命令唯一标识" v-model="queryParam.commandId"></a-input>
                      </a-form-item>
                    </a-col> -->
                    <!-- 
                    <a-col :xl="6" :lg="7" :md="8" :sm="24">
                      <a-form-item label="命令参数">
                        <a-input placeholder="请输入命令参数" v-model="queryParam.cmdParam"></a-input>
                      </a-form-item>
                    </a-col>
                    <a-col :xl="6" :lg="7" :md="8" :sm="24">
                      <a-form-item label="命令内容">
                        <a-input placeholder="请输入命令内容" v-model="queryParam.cmdContent"></a-input>
                      </a-form-item>
                    </a-col> -->
                  </template>
                  <a-col :xl="6" :lg="7" :md="8" :sm="24">
                    <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                      <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                      <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
                      <a @click="handleToggleSearch" style="margin-left: 8px">
                        {{ toggleSearchStatus ? $t('收起') : $t('展开') }}
                        <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
                      </a>
                    </span>
                  </a-col>
                </a-row>
              </a-form>
            </div>
            <!-- table区域-begin -->
            <div class="table-operator">
              <a-button type="primary" icon="download" @click="handleExportXls($t('命令队列'))">{{ $t('导出') }}</a-button>
            </div>
            <div class="table-fixed">
              <span style="float:right;">
                <a-popover :title="$t('自定义列')" trigger="click" placement="leftBottom">
                  <template slot="content">
                    <a-checkbox-group @change="onColSettingsChange" v-model="settingColumns" :defaultValue="settingColumns">
                      <a-row>
                        <template v-for="item in defColumns">
                          <template v-if="item.key!='rowIndex'&& item.dataIndex!='action'">
                            <a-col :span="12" :key="item.key"><a-checkbox :value="item.dataIndex">{{ item.title }}</a-checkbox></a-col>
                          </template>
                        </template>
                      </a-row>
                    </a-checkbox-group>
                  </template>
                </a-popover>
              </span>
              <a-table
                ref="table"
                size="middle"
                bordered
                rowKey="id"
                :columns="columns"
                :dataSource="dataSource"
                :pagination="ipagination"
                :loading="loading"
                :scroll="{x: true}"
                :components="drag(columns)"
                @change="handleTableChange">
                <div slot="filterDropdown">
                  <a-card>
                    <a-checkbox-group @change="onColSettingsChange" v-model="settingColumns" :defaultValue="settingColumns">
                      <a-row>
                        <template v-for="item in defColumns">
                          <template v-if="item.key!='rowIndex'&& item.dataIndex!='action'">
                            <a-col :span="12" :key="item.key">
                              <a-checkbox :value="item.dataIndex">{{ item.title }}</a-checkbox>
                            </a-col>
                          </template>
                        </template>
                      </a-row>
                    </a-checkbox-group>
                  </a-card>
                </div>
                <a-icon slot="filterIcon" type='down' :style="{ fontSize:'12px',color: '#108ee9'}" />
                <span slot="action" slot-scope="text, record">
                  <!-- <a @click="handleDetail(record)">详情</a> -->
                  <a @click="handleCommandQueue(record)">{{ $t('详情') }}</a>
                  <a-divider type="vertical" />
                  <a :disabled="['2','3','4','-1'].includes(record.status)||record.cmd === '10'||record.cmd === '902f'"  @click="cancel(record)">{{ $t('取消') }}</a>
                </span>
              </a-table>
            </div>
            <!-- table区域-end -->
            <partCommand-old-modal ref="modalOldForm" @ok="modalOldForm"></partCommand-old-modal>
            <partCommand-modal ref="modalForm" @ok="modalFormOk"></partCommand-modal>
            <partCommand-dykj-modal ref="modalDykjForm" @ok="modalFormOk"></partCommand-dykj-modal>
            <partUSCommand-modal ref="usModalForm" @ok="modalFormOk"></partUSCommand-modal>
            <partCommand-common-modal ref="modalCommonForm" @ok="modalFormOk"></partCommand-common-modal>
          </a-card>
            
        </a-col>
      </a-row>
    </a-tab-pane>
    <a-tab-pane :key="2" :tab="$t('命令任务列表')" class="new-tab-pane-block">
     <meter-the-batch-tash-comp :taskType="5" :isCanCreate="false"></meter-the-batch-tash-comp>
    </a-tab-pane>
  </a-tabs>
</div>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import {isUndefined} from'@/utils/validate'
  import PartCommandOldModal from './modules/PartCommandOldModal'
  import PartCommandDykjModal from './modules/PartCommandDykjModal'
  import PartCommandModal from './modules/PartCommandModal'
  import PartUSCommandModal from './modules/PartUSCommandModal'
  import PartCommandCommonModal from './modules/PartCommandCommonModal'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {AreaChoosetMixin} from '@/mixins/AreaChooseMixin'
  import configService from '@/utils/service/config.service'
  import { validateDuplicateValue,listSize } from '@/utils/util'
  import { getAction,putAction } from '@/api/manage'
  import moment from 'moment'
  import Vue from 'vue'
  import {dataFlagObj,reportStatusObj,MN100DataFlagObj,WN100DataFlagObj,MN1002DDataFlagObj} from '@/utils/constants/protocolConstant'
  import {meterTypeObj} from '@/utils/constants/commonConstant'
  import meterTheBatchTashComp from '@/views/meterManagement/meterTheBatchTashComp'
  import {filterDictTextByCache} from '@/components/dict/JDictSelectUtil'
  import TableDragResize  from '@/mixins/TableDragResize'
  
  export default {
    name: "serviceQueueList",
    mixins:[JeecgListMixin,AreaChoosetMixin,TableDragResize],
    components: {
      PartCommandOldModal,
      PartCommandModal,
      meterTheBatchTashComp,
      PartCommandDykjModal,
      PartUSCommandModal,
      PartCommandCommonModal
    },
    data () {
      return {
        description: '命令队列',
        meterTypeObj,
        reportStatusObj,
        MN100DataFlagObj,
        WN100DataFlagObj,
        MN1002DDataFlagObj,
        date:[],
        userTypeList:[],  //表类型
        cmdList:{},//MN100DataFlagObj,  //命令标识
        beginDate: null,
        endDate: null,
        endOpen: false,
        columns:[],
        collapsed: false,
        //列设置
        settingColumns:[],
        url: {
          list: "/jeecg-charge/meter/command/list",
          delete: "/model/partCommand/delete",
          deleteBatch: "/model/partCommand/deleteBatch",
          exportXlsUrl: "/jeecg-charge/meter/command/exportXls",
          importExcelUrl: "model/partCommand/importExcel",
          userTypeList:"/jeecg-charge/meter/meterType/list",  //表类型请求地址
          cancel:"/jeecg-charge/meter/command/delete",
          dykjCancel: "/jeecg-charge/meter/dykj/deleteCommand",
        },
        activeKey: 1
      }
    },
    created() {
      this.$store.commit('SET_LAYOUT_TREE',true)
      this.queryUserTypeList();
      this.initColumns();
    },
    computed: {
      importExcelUrl: function(){
        return `${configService.apiUrl}/${this.url.importExcelUrl}`;
      },
      // i18n：列定义使用 computed 以响应语言切换
      defColumns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:(t,r,index) => {
              return parseInt(index)+1;
            },
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon'
            }
          },
          {
            title: this.$t('用户编号'),
            align:"center",
            dataIndex: 'userId',
            width:150,
            ellipsis: true
          },{
            title: this.$t('用户姓名'),
            align:"center",
            dataIndex: 'userName',
            width:150,
            ellipsis: true
          },{
            title: this.$t('表编号'),
            align:"center",
            dataIndex: 'meterId',
            width:150,
            ellipsis: true
          },{
            title: this.$t('用户地址'),
            align:"center",
            dataIndex: 'userAddr',
            customRender:(t,r,index) => {
              if(r.userAreaName){
                let i = r.userAreaName.indexOf('-');
                return r.userAreaName.slice(i+1,r.userAreaName.length)+'-'+t;
              }else{
                return t
              }
            },
            width:150,
            ellipsis: true
          },{
            title: this.$t('表类型'),
            align:"center",
            dataIndex: 'mtName',
            width:100,
            ellipsis: true
          },{
            title: this.$t('命令标识'),
            align:"center",
            dataIndex: 'cmd',
            customRender:(text) => {
              return this.$t(dataFlagObj[text])
            },
            width:150,
            ellipsis: true
          },{
            title: this.$t('运营商'),
            align:"center",
            dataIndex: 'mtIotType',
            customRender: (text) => {
              //字典值替换通用方法
              return filterDictTextByCache('mtIotType', text);
            },
            width: 80
          },{
            title: this.$t('命令ID'),
            align:"center",
            dataIndex: 'commandId',
            width:150,
            ellipsis: true
          },{
            title: this.$t('通讯状态'),
            align:"center",
            dataIndex: 'status',
            customRender:(t,r,index) => {
              let data = reportStatusObj
              if(isUndefined(data[t])) {
                return this.$t("其他")
              }
              return this.$t(data[t])
            },
            width:100,
            ellipsis: true
          },{
            title: this.$t('发送时间'),
            align:"center",
            dataIndex: 'sendTime',
             width:150,
            ellipsis: true
          },{
            title: this.$t('接收回应时间'),
            align:"center",
            dataIndex: 'receiveTime',
            width:150,
            ellipsis: true
          },{
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ]
      }
    },
    methods: {
      changeMeterType(e) {
        console.log(e)
        if(isUndefined(e)) {
          return;
        }else{
          this.queryParam.meterType = e
        }
        
        if(e == '80') {
          this.cmdList = this.WN100DataFlagObj
        }else if(e == '18') {
          this.cmdList = this.MN100DataFlagObj
        }else if(e == 'MN100-2D') {
          this.cmdList = MN1002DDataFlagObj
        }
      },
      changeTab() {

      },
      handleCommandQueue(record) {
        if(record.meterType == '80') {
          this.handleDetail(record);
        }else if(record.meterType == '15') {
          this.handleUSDetail(record);
        }else if(record.meterType == 'MN100-2D') {
          this.handleDykjDetail(record);
        }else if(record.meterType == '17'||record.meterType == '18') {
          this.handleDetails(record)();
        }else {
          // 通用
          this.handleCommonDetail(record);
        }
      },
      handleUSDetail(record){
        this.$refs.usModalForm.edit(record);
        this.$refs.usModalForm.title=this.$t("详情");
        this.$refs.usModalForm.disableSubmit = true;
      },
      handleDetails(record){
        this.$refs.modalOldForm.edit(record);
        this.$refs.modalOldForm.title=this.$t("详情");
        this.$refs.modalOldForm.disableSubmit = true;
      },
      handleDykjDetail(record){
        this.$refs.modalDykjForm.edit(record);
        this.$refs.modalDykjForm.title=this.$t("详情");
        this.$refs.modalDykjForm.disableSubmit = true;
      },
      handleCommonDetail(record){
        this.$refs.modalCommonForm.edit(record);
        this.$refs.modalCommonForm.title=this.$t("详情");
        this.$refs.modalCommonForm.disableSubmit = true;
      },
      modalOldForm() {
      // 新增/修改 成功时，重载列表
      this.loadData();
      },
      queryUserTypeList() {   //表类型请求
        let params = {}
        params.pageNo = 1;
        params.pageSize = listSize;
        getAction(this.url.userTypeList, params).then((res) => {
          if(res.success){
            this.userTypeList = res.result.records;
            console.log(this.userTypeList);
          }
        }) 
      },
      cancel(record) {   //取消点击事件
      let str
        let _this= this
        this.$confirm({
          title: this.$t('你确定要撤销该条记录吗?'),
          content: h => <div style="color:red;">{record.meterType == 'MN100-2D'?this.$t('表类型MN100-2D的撤销操作是针对单个设备的，点击撤销会撤销该设备的全部未执行的命令。'):''}</div>,
          onOk() {
            _this.revocation(record)
          },
          onCancel() {
          }
        });
      },
      revocation(record) {    //取消操作
        const that = this;
        let data = {};
        // params.id = record.id
        data.id = record.id
        let url = this.url.cancel
        if(record.meterType == 'MN100-2D') {
          // 端云科技大口径水表
          url = this.url.dykjCancel;
        }
        putAction(url+'?id='+record.id, {}).then((res)=>{
            if(res.success&&res.code === 0){
              that.$message.success(res.message);
            }else{
              that.$message.warning(res.message);
            }
          }).finally(() => {
            this.loadData();
          })
      },
      //列设置更改事件
      onColSettingsChange (checkedValues) {
        var key = this.$route.name+":colsettings";
        Vue.ls.set(key, checkedValues, 7 * 24 * 60 * 60 * 1000)
        this.settingColumns = checkedValues;
        const cols = this.defColumns.filter(item => {
          if(item.key =='rowIndex'|| item.dataIndex=='action'){
            return true
          }
          if (this.settingColumns.includes(item.dataIndex)) {
            return true
          }
          return false
        })
        this.columns =  cols;
      },
      initColumns(){
        //权限过滤（列权限控制时打开，修改第二个参数为授权码前缀）
        //this.defColumns = colAuthFilter(this.defColumns,'testdemo:');
        var key = this.$route.name+":colsettings";
        let colSettings= Vue.ls.get(key);
        if(colSettings===null||colSettings==undefined){
          let allSettingColumns = [];
          this.defColumns.forEach(function (item,i,array ) {
            allSettingColumns.push(item.dataIndex);
          })
          this.settingColumns = allSettingColumns;
          this.columns = this.defColumns;
        }else{
          this.settingColumns = colSettings;
          const cols = this.defColumns.filter(item => {
            if(item.key =='rowIndex'|| item.dataIndex=='action'){
              return true;
            }
            if (colSettings.includes(item.dataIndex)) {
              return true;
            }
            return false;
          })
          this.columns =  cols;
        }
      },
      onOk(value) {
        console.log('onOk: ', value);
      }
    }
  }
</script>
<style scoped>
  .card-container {
  overflow: hidden;
  height: 100%;
}
.card-container /deep/ .ant-tabs-content {
  margin-top: -16px;
}
.card-container /deep/ .ant-tabs-bar {
  background-color: #fff;
}

.card-container /deep/  .ant-tabs-content  .ant-tabs-tabpane {
  background: #fff;
  padding: 16px;
}

.card-container /deep/  .ant-tabs-bar {
}

.card-container /deep/  .ant-tabs-bar .ant-tabs-tab {
  border-color: transparent;
  background: transparent;
}

.card-container /deep/ .ant-tabs-bar .ant-tabs-tab-active {
  background: #fff;
}
.my-area-select-tree /deep/ li .ant-tree-node-content-wrapper{
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    white-space: nowrap;
  }
</style>